import styled, { css } from "styled-components";
import Select from "../../../img/icons/select.svg";

export const ChipRowWrapper = styled.div`
  padding: 0 ${({ theme }) => theme.space[2]};
`;

export const ChipRow = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.space[1]};
  overflow-x: auto;
  scroll-behavior: smooth;
  scrollbar-width: thin;
  scrollbar-color: ${({ theme }) => theme.colors.greyBlue} transparent;

  &::-webkit-scrollbar {
    height: 2px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.colors.greyBlue};
    border-radius: 2px;
  }
`;

export const ChipWrap = styled.div`
  position: relative;

  &::after {
    content: "";
    background: url(${Select}) no-repeat center;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 12px;
    height: 8px;
    background-size: contain;
    inset-inline-end: 10px;
    pointer-events: none;
  }
`;

/** Invisible span: same font as ChipSelect, used only to measure selected option text width. */
export const OffscreenLabelMeasure = styled.span`
  position: absolute;
  visibility: hidden;
  white-space: nowrap;
  font-size: ${({ theme }) => theme.fontSizes[1]};
  font-family: ${({ theme }) => theme.fonts.body};
  pointer-events: none;
`;

/** Shared styles for filter dropdown chips and reset button */
export const filterChipBaseStyles = css`
  border: ${({ theme }) => theme.borders[1]};
  border-radius: ${({ theme }) => theme.radii[1]};
  background-color: ${({ theme }) => theme.colors.greyLighter};
  color: ${({ theme }) => theme.colors.offBlack};
  font-family: ${({ theme }) => theme.fonts.body};
  font-size: ${({ theme }) => theme.fontSizes[1]};
  padding: ${({ theme }) => theme.space[1]};
  cursor: pointer;
`;

export const ChipSelect = styled.select`
  ${filterChipBaseStyles}
  appearance: none;
  min-width: 60px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-inline-end: 28px;
`;

export const ResetChip = styled.button`
  ${filterChipBaseStyles}
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.space[1]};

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;
